import {baseApi} from './baseApi';

export const injectedProcessApi = baseApi.injectEndpoints({
    addTagTypes: ['Process'],
    endpoints: (builder) => ({
        getProcessOverview: builder.query({
            query: (args) => {
                const {projectId, mapping} = args;

                let url = `getProcessOverview?project_id=${projectId}`;

                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['Process']
        }),
        refetchErroredQueries: builder.mutation({
            queryFn: () => ({data: null}),
            invalidatesTags: ['UNKNOWN_ERROR'],
        }),
        createProcess: builder.mutation({
            query: (data) => ({
                url: 'createProcess',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Process']
        }),
        updateProcess: builder.mutation({
            query: (data) => ({
                url: 'updateProcess',
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Process']
        }),
        deleteProcess: builder.mutation({
            query: (data) => ({
                url: 'deleteProcess',
                method: 'DELETE',
                body: data,
            }),
            invalidatesTags: ['Process']
        }),
        updateArrayMapping: builder.mutation({
            query: (data) => ({
                url: 'updateArrayMapping',
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Process', 'User']
        }),
    }),
});

export const {
    useGetProcessOverviewQuery,
    useCreateProcessMutation,
    useUpdateProcessMutation,
    useDeleteProcessMutation,
    useUpdateArrayMappingMutation,
} = injectedProcessApi;
